export default "__VITE_ASSET__CG6_4owQ__"